export default "__VITE_ASSET__DTAKkPMe__"